import type { BrandTokens, ThemePreset } from "../styles/theme/types";

type CustomerTheme = {
  preset?: ThemePreset;
  brand?: Partial<BrandTokens>;
};

type CustomerConfig = {
  api: string;
  blogBase?: {
    de: string;
    en: string;
  };
  theme?: CustomerTheme;
};

export const customers: Record<string, CustomerConfig> = {
  kunde1: {
    api: "https://svenfleshman.moniuk.net/wp-json",
    blogBase: { de: "blog", en: "news" }
  },
  kunde2: {
    api: "https://kunde2.moniuk.net/wp-json",
    blogBase: { de: "blog", en: "news" }
  },
  default: {
    api: "https://wp.moniuk.net/wp-json",
    blogBase: { de: "blog", en: "news" },
    theme: {
      preset: "material",
      brand: {
        primary: "#0f8f8e",
        secondary: "#0d3640",
        accent: "#f3b23a",
        background: "#f7f9fb",
        text: "#0b1f27",
        fontFamily: "\"Source Sans 3\", \"Segoe UI\", sans-serif",
        radius: 10
      }
    }
  }
};
